import { use } from "react";
import AuthContext from "./AuthContext";

// Custom hook for easy access
export const useAuth = () => {
  const ctx = use(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};